import { gql } from '@apollo/client';

export const SEARCH_BIB_ITEMS_LOGGED = gql`
  query searchBibItems(
    $searchValue: String
    $searchType: String
    $calculatedItemPolicyForPatronWhere: PatronWhereUniqueInput!
  ) {
    simpleSearchBibliographicsRecords_v2(
      searchValue: $searchValue
      searchType: $searchType
    ) {
      records {
        id
        _physicalManifestations_count
        _physicalManifestations {
          guid
          barcode
          warehouseIdentifierUniqueString
          hasActiveLoan
          hasReservation
          hasRequests
          intendedLocation {
            guid
            displayName
          }
          virtualCollection {
            id
            displayName
          }
          semanticCategory {
            displayName
          }
          semanticStatus {
            displayName
          }
          #extraMetaDatas_m2m {
          #  guid
          #  value
          #  status
          #  metaDataType {
          #    guid
          #    code
          #    displayName
          #  }
          #}
          calculatedItemPolicyForPatron(
            where: $calculatedItemPolicyForPatronWhere
          ) {
            id
            displayName
            rules {
              id
              ruleType
              ruleValue
            }
          }
        }
      }
    }
  }
`;

export const SEARCH_BIB_ITEMS_UNLOGGED = gql`
  query searchBibItems($searchValue: String, $searchType: String) {
    simpleSearchBibliographicsRecords_v2(
      searchValue: $searchValue
      searchType: $searchType
    ) {
      records {
        id
        _physicalManifestations_count
        _physicalManifestations {
          guid
          barcode
          warehouseIdentifierUniqueString
          hasActiveLoan
          hasReservation
          hasRequests
          intendedLocation {
            guid
            displayName
          }
          virtualCollection {
            id
            displayName
          }
          semanticCategory {
            displayName
          }
          semanticStatus {
            displayName
          }
          #extraMetaDatas_m2m {
          #  guid
          #  value
          #  status
          #  metaDataType {
          #    guid
          #    code
          #    displayName
          #  }
          #}
        }
      }
    }
  }
`;
